import {
  HIDE_NAVIGATION_MODAL,
  SHOW_NAVIGATION_MODAL,
  SHOW_BONUS_CONFIRM_BONUS_MODAL,
  HIDE_BONUS_CONFIRM_BONUS_MODAL,
  SHOW_SORT_PROVIDERS_MODAL,
  HIDE_SORT_PROVIDERS_MODAL,
  SHOW_CURRENCY_CONFIRM_MODAL,
  HIDE_CURRENCY_CONFIRM_MODAL,
  SHOW_RECENTS_GAMES_MIGRATION_PROCESS_MODAL,
  HIDE_RECENTS_GAMES_MIGRATION_PROCESS_MODAL,
  SHOW_LOSS_LIMITS_MODAL,
  HIDE_LOSS_LIMITS_MODAL,
} from '../../constants/modals';

export const showNavigationModal = () => ({
  type: SHOW_NAVIGATION_MODAL,
});
export const hideNavigationModal = () => ({
  type: HIDE_NAVIGATION_MODAL,
});

export const showSortProvidersModal = () => ({
  type: SHOW_SORT_PROVIDERS_MODAL,
});
export const hideSortProvidersModal = () => ({
  type: HIDE_SORT_PROVIDERS_MODAL,
});

// Confirm bonuses actions
export const showBonusConfirmModal = () => ({
  type: SHOW_BONUS_CONFIRM_BONUS_MODAL,
});
export const hideBonusConfirmModal = () => ({
  type: HIDE_BONUS_CONFIRM_BONUS_MODAL,
});

export const showCurrencyConvertationModal = () => ({
  type: SHOW_CURRENCY_CONFIRM_MODAL,
});
export const hideCurrencyConvertationModal = () => ({
  type: HIDE_CURRENCY_CONFIRM_MODAL,
});

export const showLossLimitsModal = () => ({
  type: SHOW_LOSS_LIMITS_MODAL,
});

export const hideLossLimitsModal = () => ({
  type: HIDE_LOSS_LIMITS_MODAL,
});

export const showRecentGamesModal = () => ({
  type: SHOW_RECENTS_GAMES_MIGRATION_PROCESS_MODAL,
});
export const hideRecentGamesModal = () => ({
  type: HIDE_RECENTS_GAMES_MIGRATION_PROCESS_MODAL,
});
